import { ESdChangeReason } from "@kuika/kuika-cl-model";
import CommandInterceptor from "diagram-js/lib/command/CommandInterceptor";
import EventBus from "diagram-js/lib/core/EventBus";
import { ScreenDesignContextProvider } from "../../../../contexts/screen-design-context/screen-design-context-provider";

export default class CustomCommandInterceptor extends CommandInterceptor {
  // private syncService: WorkflowSyncService;

  constructor(
    eventBus: EventBus,
    modeling: any,
    elementRegistry: any,
    elementFactory: any,
    providerInstance: ScreenDesignContextProvider
  ) {
    super(eventBus);

    this.postExecute(
      ["element.updateProperties"],
      1000,
      (context) => {
        const { element } = context;
        if (element.businessObject.$type === "bpmn:BoundaryEvent") {
          this.UpdateBoundaryEventInteruption(element, providerInstance);
        }
      },
      true
    );
  }

  UpdateBoundaryEventInteruption = (element, providerInstance) => {
    const wf = providerInstance.workflowProvider.state.selectedWf;
    if (wf) {
      const step = providerInstance.workflowProvider.findStepRecursively(wf, (s) => s.id === element.id);
      if (step && step.boundaryEvent) {
        step.boundaryEvent.interruption = element.businessObject.cancelActivity;
        providerInstance.workflowProvider.saveWorkFlow(wf, ESdChangeReason.WorkflowListUpdate);
      }
    }
  };
}

CustomCommandInterceptor.$inject = ["eventBus", "modeling", "elementRegistry", "elementFactory", "providerInstance"];
